import { Goal } from '../../goals';
import {
    FinancialEntityOwnershipType,
    MerchantFieldsFragment,
    TransactionEntryCategoryFieldsFragment,
    TransactionEntryFieldsFragment,
} from '../../graphql/generated';
import { IconName } from '../icons';

export type CashflowFinancialEntity = {
    id: string;
    name: string;
    mask: string | undefined | null;
    institutionName: string | undefined | null;
    institutionLogo?: IconName | string | undefined | null;
    isMine: boolean;
    ownershipType: FinancialEntityOwnershipType | undefined | null;
    jointOwnerPartnershipId?: string | undefined | null;
    goal?: Goal;
};

export type CashflowTransactionEntry = TransactionEntryFieldsFragment & {
    financialEntity: CashflowFinancialEntity;
    category: TransactionEntryCategoryFieldsFragment;
};

// TODO: Update with icon names
export type BaseSpendingGroup = {
    id: string;
    name: string;
    amount: number;
    amountByMonth: {
        [key: string]: number;
    };
    category: TransactionEntryCategoryFieldsFragment;
    merchant?: MerchantFieldsFragment | null;
    budgetAmount?: number;
    adjustedBudgetAmount?: number;
    percentageOfBudget?: number;
};

export type SpendingGroupBy = 'category' | 'merchant' | 'categoryGroup';

export type TransactionEntryTag = {
    // ID is optional because we don't have IDs for the preset tags until a user assigns one for the first time
    id?: string;
    color: string;
    name: string;
};

export enum SortDirection {
    Asc = 'ASC',
    Desc = 'DESC',
}

export enum SortField {
    Amount = 'amount',
    Date = 'date',
}

export type SortValue =
    | `date,${SortDirection.Asc}`
    | `date,${SortDirection.Desc}`
    | `amount,${SortDirection.Desc}`
    | `amount,${SortDirection.Asc}`;

export interface TransactionSortOption {
    direction: SortDirection;
    field: SortField;
    label: string;
}
